import { formatDateOrTime } from "app/formatting/functions";
import React from "react";
import { DynamicLink } from "app/links/DynamicLink/DynamicLink";

import "./style.scss";

export interface Props {
    time: string;
    title: string;
    url: string;
    className?: string;
    timeFormatter?: (d: string | number | Date) => string;
}

export const LinkWithTime = ({ time, title, url, className, timeFormatter }: Props) => {
    const classNames = ["linkWithTime"];

    if (className) {
        classNames.push(className);
    }

    if (!timeFormatter) {
        timeFormatter = formatDateOrTime;
    }

    return (
        <DynamicLink className={classNames.join(" ")} href={url}>
            <span className="time">{timeFormatter(time)}</span>
            <span className="title">{title}</span>
        </DynamicLink>
    );
};
